import {connect} from "react-redux";
import CalendarPercent from "./CalendarPercent";
import {compose} from "redux";
import {
    getChannelManagerIdSelector,
    getChannelManagerLinkSelector,
    getDatesSelector,
    getDatesSelectorAll,
    getMaxTypeSelector,
    getPricesIdSelector,
    getPriceTypeSelector,
    getRatePlanInitSelector,
    getRatePlansSelector,
    getRoomNameSelector,
    getRoomsListSelector,
    getSalesActiveCloseSelector,
    getSalesActiveIdSelector,
    getSalesActiveSelector,
    getTypesSelector
} from "./selectors";
import {getPrices, updatePrices, updateRatePlan, updateSalesActive} from "./actions";
import {getPriceTypesSelector} from "../../globalState/app/selectros";
import {getPriceTypes} from "../../globalState/object/actions";


let mapStateToProps = (state, props) => {
    return {
        ratePlans: getRatePlansSelector(state),
        ratePlan: getRatePlanInitSelector(state),
        rooms: getRoomsListSelector(state),
        roomName: getRoomNameSelector(state, props),
        datesAll: getDatesSelectorAll(state),
        dates: getDatesSelector(state),
        maxTypeBD: getMaxTypeSelector(state),
        priceId: getPricesIdSelector(state),
        types: getTypesSelector(state),
        priceType: getPriceTypeSelector(state),
        salesActiveId: getSalesActiveIdSelector(state),
        salesActive: getSalesActiveSelector(state),
        salesActiveClose: getSalesActiveCloseSelector(state),
        channelManagerId: getChannelManagerIdSelector(state),
        channelManagerLink: getChannelManagerLinkSelector(state),
        priceTypes: getPriceTypesSelector(state),
    }
};

let mapDispatchToProps = (dispatch) => {
    return {}
};

export default compose(connect(mapStateToProps, {
    mapDispatchToProps,
    getPrices,
    updateRatePlan,
    updatePrices,
    updateSalesActive,
    getPriceTypes,
}))(CalendarPercent);



